import { render } from "./MyAccount.vue?vue&type=template&id=2ab341b2"
import script from "./MyAccount.vue?vue&type=script&lang=js"
export * from "./MyAccount.vue?vue&type=script&lang=js"
script.render = render

export default script